import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), 'SignalWifi4BarSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalWifi4BarSharp.js
// module id = 6246
// module chunks = 2